import { IconInformationFill, IconSize } from "@amzn/stencil-react-icons";
import React from "react";

interface InfoIconButtonProps {
  iconSize: IconSize;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  "data-testid"?: string;
}

const InfoIconButton = React.forwardRef<HTMLButtonElement, InfoIconButtonProps>(
  ({ iconSize, onClick, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        style={{
          cursor: "pointer",
          display: "inline-block",
          verticalAlign: "middle",
          marginLeft: "4px",
          paddingBottom: "3px",
          border: "none",
          background: "none",
          margin: 0,
          font: "inherit",
          color: "inherit",
          outline: "none",
        }}
        {...props}
      >
        <IconInformationFill size={iconSize} color="#6B7280" />
      </button>
    );
  }
);

InfoIconButton.displayName = "InfoIconButton";

export default InfoIconButton;
